var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZvukColorDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 50,
    viewBox: "0 0 95 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Zvuk"
  }, /*#__PURE__*/React.createElement("g", {
    id: "zvuk-color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_ru"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 20,
    cy: 26,
    r: 20,
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1-Copy-47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M23.5754 26.8972C21.936 26.8972 20.6023 28.3203 20.6023 30.0698C20.6023 30.0812 20.6026 30.0925 20.6031 30.1002C20.5958 30.3656 20.6306 31.2111 21.2462 32.3762C22.0529 33.9028 23.503 35.3351 25.5568 36.634C25.5968 36.6639 25.6422 36.6874 25.6915 36.7029C25.7358 36.7168 25.7812 36.7237 25.8265 36.7237C25.8743 36.7237 25.922 36.716 25.9671 36.7011C26.0206 36.682 26.0561 36.6634 26.0883 36.6407C28.1422 35.3418 29.5923 33.9095 30.399 32.3828C31.0145 31.2178 31.0494 30.3723 31.042 30.1067C31.0424 30.0992 31.0429 30.0878 31.0429 30.0765C31.0429 28.327 29.709 26.9039 28.0696 26.9039C27.1884 26.9039 26.0883 27.4063 25.8259 28.5483C25.5568 27.3996 24.4568 26.8972 23.5754 26.8972Z",
    fill: "url(#paint0_linear_108_363)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M21.5938 14.0611C21.4536 13.981 21.2798 13.9795 21.1383 14.0575C20.9968 14.1355 20.9094 14.2809 20.9094 14.4386V24.309C20.9094 24.4664 20.9968 24.612 21.1383 24.69C21.2079 24.7284 21.2853 24.7477 21.3627 24.7477C21.4427 24.7477 21.5226 24.7271 21.5938 24.6864L30.2065 19.7513C30.3443 19.6722 30.4288 19.5287 30.4288 19.3737C30.4288 19.2188 30.3443 19.0752 30.2065 18.9962L21.5938 14.0611Z",
    fill: "url(#paint1_linear_108_363)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    d: "M17.5316 14.8652C17.5316 14.6585 17.417 14.4686 17.2335 14.3712C16.7375 14.1079 15.9719 14.6944 15.9719 15.4256V29.8409C13.0103 28.4213 9.54761 30.6009 9.54761 33.5478C9.54761 35.1069 10.5825 36.4166 12.9369 36.4166C15.2642 36.4166 17.5184 34.3239 17.5316 30.7376V14.8652Z",
    fill: "url(#paint2_linear_108_363)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1-Copy-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    d: "M84.7053 22.2991H88.1454L87.4297 25.8067H88.4635L90.9494 22.2991H94.8866L90.9294 27.4541V27.4926L93.2958 32.2796H89.5772L87.9464 28.6169H86.8731L86.137 32.2796H82.6969L84.7053 22.2991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    d: "M72.3574 33.5589C72.954 33.5589 73.6701 33.4039 74.2067 32.551L74.5052 32.0856L72.0989 22.2991H75.6785L76.5136 27.241C76.6127 27.7835 76.6127 28.7139 76.6127 28.7139H76.6527C76.6527 28.7139 77.0107 27.842 77.2692 27.2991L79.5557 22.2991H83.4139L77.0107 33.3455C75.738 35.5357 73.9682 36.3496 72.5364 36.3496C71.6217 36.3496 70.6471 36.0782 69.8519 35.5742L71.3432 33.2489C71.6018 33.4424 72.0193 33.5589 72.3574 33.5589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7645 22.2991H62.2765L60.2677 32.2796H65.9552C68.1226 32.2796 70.4095 31.1946 70.4095 29.1209C70.4095 28.3069 70.0514 27.4346 69.1767 27.1051V27.086C70.3699 26.5432 70.867 25.5158 70.867 24.6053C70.867 23.1325 69.6339 22.2991 67.7645 22.2991ZM66.2137 26.2332C66.8898 26.2332 67.4465 25.7098 67.4465 25.1088C67.4465 24.6828 67.1679 24.3728 66.5518 24.3728H65.299L64.921 26.2332H66.2137ZM65.6371 30.1863C66.2932 30.1863 66.9694 29.6828 66.9694 28.9659C66.9694 28.5009 66.6708 28.1905 66.0547 28.1905H64.5234L64.1258 30.1863H65.6371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-1_2",
    d: "M50.5249 28.2294C51.2406 29.0628 52.3347 29.5472 53.3485 29.5472C54.5021 29.5472 55.6354 28.9268 55.6354 27.7449C55.6354 27.0665 55.2178 26.6985 54.1836 26.6985H52.1353L52.6724 23.9849H54.4026C55.3768 23.9849 56.371 23.3069 56.371 22.2795C56.371 21.5821 55.9934 21.1361 54.9792 21.1361C54.2632 21.1361 53.3289 21.3496 51.9763 22.2795L50.7435 19.8187C52.4338 18.5199 54.3031 18.1904 55.5559 18.1904C58.0218 18.1904 60.0501 19.3338 60.0501 21.6595C60.0501 23.2294 59.036 24.5278 57.5247 25.1283L57.5047 25.1672C58.4789 25.6131 59.195 26.6015 59.195 27.8804C59.195 30.7486 56.232 32.5124 53.3685 32.5124C51.4396 32.5124 49.5903 31.7175 48.5361 30.3997L50.5249 28.2294Z",
    fill: "white"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_108_363",
    x1: 14.7091,
    y1: 31.1771,
    x2: 24.4463,
    y2: 42.8566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_108_363",
    x1: 14.8422,
    y1: 20.8501,
    x2: 28.062,
    y2: 30.0357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99F6B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_108_363",
    x1: 9.54761,
    y1: 14.3071,
    x2: 9.54761,
    y2: 36.4166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5FBFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZvukColorDark);
export default __webpack_public_path__ + "static/media/zvuk-color-dark.0fc6262d9b562cbaa0536f0f9905e0e7.svg";
export { ForwardRef as ReactComponent };